import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import { Dialog } from "../../types";

const batchHistorySectionUrl = "/payout/batch-history";

export const batchHistoryPath = batchHistorySectionUrl;

export const batcHistoryDetailsPath = (id: string) =>
  urlJoin(batchHistorySectionUrl, id);

export type BatchHistoryDetailsUrlDialog = "cancel" | "reject" | "download";

export type BatchHistoryUrlQueryParams = Dialog<BatchHistoryDetailsUrlDialog>;

export const batchHistoryUrl = (params: BatchHistoryUrlQueryParams) => {
  if (params === undefined) {
    return batchHistorySectionUrl;
  }

  return urlJoin(batchHistorySectionUrl, "?" + stringifyQs(params));
};

export const batchHistoryDetailsUrl = (
  id: string,
  params?: BatchHistoryUrlQueryParams
) => batcHistoryDetailsPath(id) + "?" + stringifyQs(params);
